export const UNKNOWN_LINK_TYPE = 'UNKNOWN_LINK_TYPE';
export const FILE_LINK_TYPE = 'FILE_LINK_TYPE';
export const FOLDER_LINK_TYPE = 'FOLDER_LINK_TYPE';
